// extracted by mini-css-extract-plugin
export default {"form-section":"b6dbb5","form-section__header":"ef9f2a","form-section__title":"af6f0a","form-section__title-actions":"b89f55"};